<template>
  <div class="tileView">
    <PageTopForm>
      <div slot="form">
        <el-form-item label="字典名称：">
          <el-input v-model="formInline.dictName" placeholder="请输入" clearable @keyup.enter.native="onSubmit"></el-input>
        </el-form-item>
        <el-form-item label="字典类型：">
          <el-input v-model="formInline.dictType" placeholder="请输入" clearable @keyup.enter.native="onSubmit"></el-input>
        </el-form-item>
        <el-form-item label="状态：">
          <el-select v-model="formInline.status" placeholder="请选择" clearable @keyup.enter.native.stop="onSubmit">
            <el-option label="正常" value="0"></el-option>
            <el-option label="禁用" value="1"></el-option>
          </el-select>
        </el-form-item>
        <div class="search-btn">
          <el-button type="primary" @click="onSubmit">查询</el-button>
          <el-button type="default" @click="reset">重置</el-button>
        </div>
      </div>
    </PageTopForm>
    <div class="topButtons">
      <el-button type="primary" icon="el-icon-document-add" @click="openAddDict">新建</el-button>
      <el-button type="danger" icon="el-icon-delete" :disabled="selectedData.length<=0" @click="deleteMore">删除</el-button>
    </div>
    <el-table
        ref="multipleTable"
        stripe
        :data="tableData"
        max-height="720"
        tooltip-effect="dark"
        style="width: 100%"
        @selection-change="handleSelectionChange">
      <el-table-column
        type="selection"
        class="selection"
        width="55">
      </el-table-column>
      <el-table-column label="序号" width="50">
        <template slot-scope="scope">
          <span class="num">{{scope.$index+1}}</span>
        </template>
      </el-table-column>
      <el-table-column
        v-for="(item ,index) in columns"
        :key="index"
        :prop="item.prop"
        :label="item.label"
        :width="item.width"
        :formatter="item.formatter"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column label="操作" width="160">
        <template slot-scope="scope">
<!--          <div class="action-btn">-->
<!--            <span @click="openEditDict(scope.row)">编辑</span>-->
<!--            <span class="line"></span>-->
<!--            <span @click="openDictTable(scope.row)">列表</span>-->
<!--            <span class="line"></span>-->
<!--            <span @click="deleteOne(scope.row)">删除</span>-->
<!--          </div>-->
          <div class="action-btn">
            <el-tooltip content="编辑" placement="top" effect="light" :open-delay="1000" :enterable="false">
              <Icon name="icon-edit" @click="openEditDict(scope.row)"></Icon>
            </el-tooltip>
            <el-tooltip content="列表" placement="top" effect="light" :open-delay="1000" :enterable="false">
              <Icon name="icon-table-a" @click="openDictTable(scope.row)"></Icon>
            </el-tooltip>
            <el-tooltip content="删除" placement="top" effect="light" :open-delay="1000" :enterable="false">
              <Icon name="icon-ashbin" @click="deleteOne(scope.row)"></Icon>
            </el-tooltip>
          </div>
        </template>
      </el-table-column>
      <template slot="empty">
        <Empty></Empty>
      </template>
    </el-table>
    <div class="page-bottom">
      <div class="page-wrapper">
        <div class="bottom-left">
          <span class="title">已选择</span><span class="value">{{selectedData.length}}</span><span  class="title">项，共</span><span class="value">{{total}}</span><span class="title">条</span>
        </div>
        <div class="bottom-right">
          <el-pagination
              @size-change="onSizeChange"
              @current-change="onCurrentChange"
              :current-page="currentPage"
              :page-size="pageSize"
              :hide-on-single-page="pageSize>=tableData.length"
              layout="prev, pager, next, jumper"
              :total="total">
          </el-pagination>
        </div>

      </div>
    </div>
    <Dict ref="dictDialog" @refresh="refreshTable"></Dict>
    <DictTable ref="dictTableDialog" @refresh="refreshTable"></DictTable>
  </div>
</template>

<script>
import Dict from './Dialog/Dict'
import DictTable from './Dialog/DictTable'
import PageTopForm from '@/components/PageTopForm/PageTopForm'
import { getDictList, deleteDict } from '@/api/system'
import page from '@/mixins/page'
export default {
  name: 'Tile',
  props: {},
  mixins: [page],
  components: { PageTopForm, Dict, DictTable },
  data () {
    return {
      formInline: {
        pageNumber: 1,
        pageSize: 15,
        dictName: '',
        dictType: '',
        status: ''
      },
      columns: [
        {
          prop: 'dictName',
          label: '字典名称'
        },
        {
          prop: 'dictType',
          label: '字典类型'
        },
        {
          prop: 'status',
          label: '字典状态',
          formatter: (row, column) => {
            return this.statusName(row.status)
          }
        },
        {
          prop: 'remark',
          label: '备注'
        },
        {
          prop: 'createTime',
          label: '创建时间',
          formatter: (row, column) => {
            return new Date(row.createTime).format('yyyy/MM/dd hh:mm:ss')
          }
        }
      ]
    }
  },
  mounted () {
    this.loadTableData()
  },
  methods: {
    loadTableData () {
      getDictList(this.formInline).then(res => {
        if (res.code === 200) {
          this.tableData = res.data.records
          this.total = res.data.total
        }
      })
    },
    statusName (status) {
      if (status === '0') {
        return '正常'
      }
      if (status === '1') {
        return '禁用'
      }
    },
    openAddDict () {
      this.$refs.dictDialog.open('新增', 'add')
    },
    openEditDict (row) {
      this.$refs.dictDialog.open('编辑', 'edit', row)
    },
    deleteOne (row) {
      this.$Delete({
        confirm: () => {
          deleteDict(row.dictId).then(res => {
            if (res.code === 200) {
              this.$Message('success', res.msg)
              this.loadTableData()
            }
          })
        },
        cancel: () => {
        }
      })
    },
    deleteMore () {
      this.$Delete({
        confirm: () => {
          const ids = []
          this.selectedData.forEach(item => {
            ids.push(item.dictId)
          })
          deleteDict(ids.toString()).then(res => {
            if (res.code === 200) {
              this.$Message('success', res.msg)
              this.loadTableData()
            }
          })
        },
        cancel: () => {
        }
      })
    },
    openDictTable (row) {
      this.$refs.dictTableDialog.open('字典数据', '', row)
    }
  }

}
</script>

<style lang="scss" scoped>
  .tileView{
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    overflow: hidden;
    color: #ffffff;
    padding: 20px 32px 0px 32px;
  }
</style>
